/* Earthly Ones theme JS — PDP gallery, qty stepper, AJAX add-to-cart */
(function () {
  // PDP thumbnail gallery
  var thumbs = document.querySelectorAll('[data-pdp-thumb]');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      var main = document.getElementById('pdp-main-img');
      if (main && t.dataset.img) main.src = t.dataset.img;
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (w) {
    var input = w.querySelector('input');
    w.querySelectorAll('button[data-delta]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = parseInt(b.dataset.delta, 10) || 0;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + d);
      });
    });
  });

  // AJAX add-to-cart with graceful fallback to a normal form post
  var form = document.querySelector('form[data-product-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.btn-add');
      var addUrl = (window.themeRoutes && window.themeRoutes.cartAdd) || '/cart/add';
      fetch(addUrl + '.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          if (btn) {
            var old = btn.textContent;
            btn.classList.add('added');
            btn.textContent = 'Added to bag ✓';
            setTimeout(function () { btn.classList.remove('added'); btn.textContent = old; }, 2200);
          }
        })
        .catch(function () { form.submit(); });
    });
  }
})();

/* ===== Modern pass: header glass, scroll reveals, stat count-up ===== */
(function () {
  var header = document.querySelector(".header");
  if (header) {
    var onScroll = function () { header.classList.toggle("scrolled", window.scrollY > 10); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  var sels = [".section-head", ".product-card", ".collection-item", ".why-figure", ".why-text",
              ".stat-cell", ".review-card", ".contact-wrap", ".edit-text", ".edit-figure",
              ".why-two-card", ".footer-faq", ".promise-card", ".story-figures", ".story-dark-p", ".story-lede"];
  var els = [];
  sels.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el, i) {
      el.setAttribute("data-reveal", "");
      el.style.transitionDelay = Math.min(i, 5) * 80 + "ms";
      els.push(el);
    });
  });

  if (reduced || designMode || !("IntersectionObserver" in window)) {
    els.forEach(function (el) { el.classList.add("revealed"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("revealed"); io.unobserve(e.target); }
      });
    }, { threshold: .1, rootMargin: "0px 0px -30px 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  if (!reduced && !designMode && "IntersectionObserver" in window) {
    document.querySelectorAll(".stat-cell .v").forEach(function (el) {
      var m = el.textContent.trim().match(/^([0-9]+(?:\.[0-9]+)?)(.*)$/);
      if (!m) return;
      var target = parseFloat(m[1]);
      var suffix = m[2] || "";
      var decimals = (m[1].split(".")[1] || "").length;
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io2.unobserve(el);
          var t0 = null, dur = 1100;
          var step = function (ts) {
            if (!t0) t0 = ts;
            var p = Math.min((ts - t0) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = (target * eased).toFixed(decimals) + suffix;
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        });
      }, { threshold: .6 });
      io2.observe(el);
    });
  }
})();
